import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { HomeModule } from './home/home.module';
import { HomeComponent } from './home/home.component';
import { PIDComponent } from './Project/pid/pid.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { SearchPidComponent } from './Project/pid/search-pid/search-pid.component';
import { PIDStatusComponent } from './Project/pid/pid-status/pid-status.component';
import { PIDApprovalComponent } from './Project/pid/pid-approval/pid-approval.component';
import { AuthGuardResolve } from './Services/Authentication-Service/AuthGuardResolve';
import { CMasterComponent } from './Samples/cmaster/cmaster.component';
import { AddEmployeeComponent } from './employee/add-employee/add-employee.component';
import { EmployeeListComponent } from './employee/employee-list/employee-list.component';
import { DefaultComponent } from './default/default.component';
import { NewbeeComponent } from './website/newbee/newbee.component';
import { SpotlightComponent } from './website/spotlight/spotlight.component';
import { BssCurveComponent } from './website/bss-curve/bss-curve.component';
import { CareerListComponent } from './career/career-list/career-list.component';
import { AddcareerComponent } from './career/addcareer/addcareer.component';
import { CarrierAppliedComponent } from './career/carrier-applied/carrier-applied.component';
import { AddAssetComponent } from './asset/add-asset/add-asset.component';
import { EmployeeAssetComponent } from './asset/employee-asset/employee-asset.component';
import { DocuploadComponent } from './website/docupload/docupload.component';
import { PolicyListComponent } from './policies/policy-list/policy-list.component';
import { PolicyComponent } from './policies/policy/policy.component';
import { OnboardingRequestComponent } from './OnboardingRequest/onboarding-request/onboarding-request.component';
import { OnboardingRequestListComponent } from './OnboardingRequest/onboarding-request-list/onboarding-request-list.component';
import { OnboardingComponent } from './Onboarding/onboarding/onboarding.component';
import { OnboardingListComponent } from './Onboarding/onboarding-list/onboarding-list.component';
const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
  },
  { path: 'login', component: LoginComponent },
  { path: 'index', component: LoginComponent },
  // { path: 'housebl', component: HouseBLComponent },
  {
    path: 'home',
    component: HomeComponent,
    children: [
      {
        path: 'dashboard',
        component: DashboardComponent,
        resolve: {
         // user: AuthGuardResolve
        },
      },
      {
        path:'addemployee',
        component:AddEmployeeComponent
      },
      {
        path:'employeelist',
        component:EmployeeListComponent
      },
      {
        path:'newbee',
        component:NewbeeComponent
      },
      {
        path:'spotlight',
        component:SpotlightComponent
      },
      {
        path:'bsscurve',
        component:BssCurveComponent
      },
      {
        path:'addcareer',
        component:AddcareerComponent
      },
      {
        path:'careerlist',
        component:CareerListComponent
      },
      {
        path:'carrerapplied',
        component:CarrierAppliedComponent
      },
      {
        path:'addasset',
        component:AddAssetComponent
      },
      {
        path:'employeeasset',
        component:EmployeeAssetComponent
      },
      {
        path:'docupload',
        component:DocuploadComponent
      },
      {
        path: 'PID-Status',
        component: PIDStatusComponent,
        resolve: {
          user: AuthGuardResolve
        },
      },
      {
        path: 'PID-Approval',
        component: PIDApprovalComponent
      },
      {
        path: 'Policies',
        component: PolicyListComponent
      }, {
        path: 'HRPoliciyView',
        component: PolicyComponent
      },
      {
        path: 'Onboarding',
        component: OnboardingComponent
      },

      {
        path: 'OnboardingList',
        component: OnboardingListComponent
      },
      {
        path: 'OnboardingRequest',
        component: OnboardingRequestComponent
      },
      {
        path: 'OnboardingRequestList',
        component: OnboardingRequestComponent
        // component: OnboardingRequestListComponent
      },
      // {
      //   path: 'EmployeeTree',
      //   component: EmployeeTree
      //   // component: OnboardingRequestListComponent
      // },
      // {
      //   path: 'searchRoleMaster',
      //   component: RoleMasterSearchComponent,
      //   outlet: 'search'
      // },

      // MASTERS
     
      //END MASTER

      //FINANCE
     
      //END FINANCE

     
      {
        path: 'cMaster',
        component: CMasterComponent,
        resolve: {
          user: AuthGuardResolve
        },
      },
    ],
    runGuardsAndResolvers: 'always',
  },
  //CREDIT NOTE
 

  // otherwise redirect to home
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(
    routes,
    {
      enableTracing: false, // <-- debugging purposes only
      //        preloadingStrategy: SelectivePreloadingStrategy,
      onSameUrlNavigation: 'reload',
      useHash: true
    }
  )],
  exports: [RouterModule, HomeModule],
})
export class AppRoutingModule { }
